<template>
  <div>
    <a-card
      class="mt-20"
      :bordered="false"
    >
      <!-- 表格筛选 start -->
      <a-form layout="inline">
        <a-form-item class="mr-20">
          <a-input
            v-model="queryParam.keyWord"
            placeholder="搜索关键字"
            allowClear
          >
            <a-select
              slot="addonBefore"
              v-model="queryParam.searchType"
              placeholder="搜索类型"
              style="width: 120px"
            >
              <a-select-option
                :value="item.id"
                :key="item.id"
                v-for="item in dict.searchTypeDict"
              >{{ item.name }}</a-select-option>
            </a-select>
          </a-input>
        </a-form-item>
        <a-form-item class="mr-20">
          <a-range-picker v-model="querytimeRange"/>
        </a-form-item>
        <a-form-item>
          <a-button
            class="mr-10"
            type="primary"
            @click="handleFilter"
          >
            搜索
          </a-button>
          <a-button @click="handleReset">
            重置
          </a-button>
        </a-form-item>
      </a-form>
      <!-- 表格筛选 end -->
      <!-- 表格内容操作 start -->
      <div class="mt-20">
        <a-button
          type="primary"
          class="mr-20"
          @click="handleExport"
        >导出</a-button>
      </div>
      <!-- 表格内容操作 end -->
      <!-- 表格 start -->
      <tcg-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        bordered
        class="mt-20"
      >
        <span
          slot="security_code"
          slot-scope="text"
          style="word-break: break-all !important;"
        >
          {{ text }}
        </span>
        <span
          slot="picture"
          slot-scope="text"
          v-if="text.length"
        >
          <img
            v-for="(img, i) in text"
            :key="i"
            :src="img"
            @click="handlePreviewPic(img)"
            style="width:64px;height:64px;margin:6px"
          />
        </span>
        <span
          slot="remark"
          slot-scope="text, record"
        >
          {{ text }}
          <a-button type="link" @click="handleEditRemark(record.feedback_id, text)">备注</a-button>
        </span>
      </tcg-table>
      <!-- 表格 end -->
    </a-card>
    <!-- 查看大图 -->
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="previewVisible = false"
      :width="500"
    >
      <img
        alt="example"
        style="width:100%; margin-top:30px"
        :src="previewImage"
      />
    </a-modal>
    <!-- 修改备注 -->
    <remark-modal ref="remarkModal" @ok="handleFilter" />
  </div>
</template>

<script>
import remarkModal from './components/remarkModal'
import { TcgTable } from '@/components'
import { getFeedbackList } from '@/api/sale'
import { downloadFile } from '@/utils'

const defaultQueryParam = {
  searchType: 'goods_name'
}

export default {
  name: 'FeedbackList',
  components: { TcgTable, remarkModal },
  data() {
    return {
      querytimeRange: [], // 选择时间
      queryParam: Object.assign({}, defaultQueryParam),
      // 字典
      dict: {
        searchTypeDict: [{ id: 'goods_name', name: '商品名称' }, { id: 'goods_id', name: '商品ID' }, { id: 'security_code', name: '云码' }, { id: 'registrant', name: '登记人' }, { id: 'phone', name: '登记电话' }, { id: 'brand_id', name: '品牌ID' }]
      },
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        if (this.querytimeRange.length) {
          this.queryParam.start_time = this.querytimeRange[0].format('YYYY-MM-DD')
          this.queryParam.end_time = this.querytimeRange[1].format('YYYY-MM-DD')
        } else {
          this.queryParam.start_time = null
          this.queryParam.end_time = null
        }
        return getFeedbackList(Object.assign(parameter, this.queryParam)).then((res) => {
          return res
        })
      },
      columns: [
        {
          title: '商品ID',
          dataIndex: 'goods_id'
        },
        {
          title: '商品名称',
          dataIndex: 'goods_name'
        },
        {
          title: '品牌ID',
          dataIndex: 'brand_id'
        },
        {
          title: '所属品牌',
          dataIndex: 'brand_name'
        },
        {
          title: '云码',
          dataIndex: 'security_code',
          scopedSlots: { customRender: 'security_code' }
        },
        {
          title: '登记人',
          dataIndex: 'registrant'
        },
        {
          title: '登记人电话',
          dataIndex: 'phone'
        },
        {
          title: '保修期限',
          dataIndex: 'maintain_expire_time'
        },
        {
          title: '反馈内容',
          dataIndex: 'content',
          width: '25%'
        },
        {
          title: '反馈图片',
          dataIndex: 'picture',
          scopedSlots: { customRender: 'picture' }
        },
        {
          title: '创建时间',
          dataIndex: 'create_time'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          scopedSlots: { customRender: 'remark' }
        }
      ],
      // 预览图片
      previewVisible: false,
      previewImage: ''
    }
  },
  methods: {
    handleFilter() {
      this.$refs.table.refresh(true)
    },
    handleReset() {
      this.queryParam = Object.assign({}, defaultQueryParam)
      this.querytimeRange = []
      this.$refs.table.refresh(true)
    },
    // 预览图片
    handlePreviewPic(pic) {
      this.previewImage = pic
      this.previewVisible = true
    },
    // 修改备注
    handleEditRemark(feedback_id, remark) {
      this.$refs.remarkModal.showModal(feedback_id, remark)
    },
    // 导出
    handleExport() {
      // window.location.href = window.location.origin + '/merchant.php/sale_feedback/outExcel'
      const href = window.location.origin + '/merchant.php/sale_feedback/outExcel'
      downloadFile(href)
    }
  }
}
</script>
